import { APIAdapter } from "../../../../helpers/api_helper";
import axios from "axios";
const api = new APIAdapter();
  export const getAllMerchent = async () => {
      try {
        const response = await api.get(`/merchants`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getMarchandById = async (merchandId) => {
      try {
        const response = await api.get(`/merchants/${merchandId}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getCompanyByMarchandId = async (merchandId) => {
    try {
      const response = await api.get(`/merchants/${merchandId}/companies`);
      return response;
    } catch (error) {
      throw error;
    }
  };
  export const deleteMerchent = async (id) => {
    try {
      const response = await api.delete(`/merchants/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
  export const activeMerchant = async ( accountId ) => {
    try {
      const response = await api.put(`/merchants/activate/${accountId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };
export const deactiveMerchant = async (accountId, reason) => {
  try {
    const response = await api.put(`/merchants/deactivate/${accountId}`, {
      reason,
    });
    return response;
  } catch (error) {
    throw error;
  }
};
export const updateKycStatus = async (merchantId,status, reason) => {
  try {
    const response = await api.create(`/kyc/validate-kyc`, {
      merchantId,
      status,
      reason
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
export const rejetKycMerchent = async (merchantId,status,reason) => {
  try {
    const response = await api.create(`/kyc/validate-kyc`, {
      merchantId,
      status:false,
      reason
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getBusinessMarchandById = async (merchandId) => {
      try {
        const response = await api.get(`/developer-account-sum/merchant/${merchandId}/summary`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getBusinessDevelopperById = async (merchandId) => {
      try {
        const response = await api.get(`/developer-account-sum/merchant/${merchandId}/summary`);
        return response;
      } catch (error) {
        throw error;
      }
  };
 export const getVersementByMarchand = async (merchantId) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-out/merchant`,
      {
        params: {
          merchant: merchantId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 MOBILE API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const getBankVersementByMarchand = async (merchantId) => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-out/banks/merchant`,
      {
        params: {
          merchant: merchantId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 BANK API ERROR:", error?.response?.data || error);
    throw error;
  }
};
   export const getMerchantTotalRevenu = async () => {
        try {
          const response = await api.get(`/admin/dashboard/merchants/total-revenue`);
          return response;
        } catch (error) {
          throw error;
        }
    }
export const createEspaceClient = async (email) => {
  try {
    const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));

    const response = await axios.post(process.env.REACT_APP_API_AUTH+
      `/auth/espace-client?email=${encodeURIComponent(email)}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${currentUser?.token}`,
        },
      }
    );
    console.log(" Espace client > ", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Erreur createEspaceClient :", error.response?.data || error);
    throw error;
  }
};
  export const getDocumentsByMarchand = async (merchandId) => {
      try {
        const response = await api.get(`/merchants/${merchandId}/kyc-files`);
       
        return response;
      } catch (error) {
        throw error;
      }
  };
export const signupMerchantAdmin = async (data) => {
  const currentUser = JSON.parse(sessionStorage.getItem("authAdmin"));
  if (!currentUser?.token) {
    console.error("❌ Aucun token trouvé. Connectez-vous !");
    throw new Error("Token manquant");
  }
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_AUTH}/auth/admin/create-merchant`,
      data,
      {
        headers: {
          Authorization: `Bearer ${currentUser.token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("❌ Erreur create merchant :", error.response?.data || error);
    throw error;
  }
};
export const getMerchantTOPRevenu = async () => {
        try {
          const response = await api.get(`/admin/dashboard/merchants/top-revenue`);
          return response;
        } catch (error) {
          throw error;
        }
}
export const getMerchantInactif = async (page = 1, size = 5) => {
        try {
          const response = await api.get(`/admin/dashboard/merchants/inactivity-kpi?page=${page}&size=${size}`);
          return response;
        } catch (error) {
          throw error;
        }
}
export const getCountryPerformanceByMarchandId = async (merchandId) => {
      try {
        const response = await api.get(`/stats/accounts/${merchandId}/country-performance`);
        return response;
      } catch (error) {
        throw error;
      }
  };
  export const getStatsAccountByMarchandId = async (merchandId) => {
      try {
        const response = await api.get(`/stats/accounts/merchant/${merchandId}`);
        return response;
      } catch (error) {
        throw error;
      }
  };
 export const getCountry = async () => {
  try {
    const currentuser = JSON.parse(sessionStorage.getItem("authAdmin"));
    const token = currentuser?.token;
    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/country`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 MOBILE API ERROR:", error?.response?.data || error);
    throw error;
  }
};  
export const searchMerchantByBusinessName = async (businessName) => {
  try {
    const response = await api.get(
      `/merchants/business?businessName=${businessName}`
    );

    return response;
  } catch (error) {
    throw error;
  }
};
